import { AfterViewInit, Component, inject } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { Notification } from '../../../models/notification';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { NotificationStore } from '../../../stores/notification/notification.state';
import { MenuItem, MessageService, PrimeTemplate } from 'primeng/api';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { NgIf } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { Button, ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-notification-list',
  standalone: true,
  imports: [
    HeaderComponent,
    MaskComponent,
    NgIf,
    PrimeTemplate,
    RouterOutlet,
    SidebarModule,
    TableCaptionComponent,
    TableListActionsComponent,
    TableModule,
    Button,
    ButtonDirective,
  ],
  templateUrl: './notification-list.component.html',
  styleUrl: './notification-list.component.scss',
})
export class NotificationListComponent
  extends BaseListComponent<Notification>
  implements AfterViewInit
{
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-8',
    icon: 'fas fa-notifications',
    headerText: 'Benachrichtigungen',
  };

  readonly store = inject(NotificationStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'notification-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  /**
   * Lifecycle hook that is called after Angular has fully initialized a component's view.
   * This method is used to configure the sidebar service with the provided sidebar configuration.
   *
   * @return {void} No return value.
   */
  ngAfterViewInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }
}
